import { render, staticRenderFns } from "./record-item.vue?vue&type=template&id=439c1f78&scoped=true"
import script from "./record-item.vue?vue&type=script&lang=js"
export * from "./record-item.vue?vue&type=script&lang=js"
import style0 from "./record-item.vue?vue&type=style&index=0&id=439c1f78&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "439c1f78",
  null
  
)

export default component.exports